import { Link  } from "react-router-dom"; 
import {FcMoneyTransfer, FcOrgUnit,FcPackage,FcManager} from "react-icons/fc";
import { FaAward} from "react-icons/fa6";
import {BsCashStack} from "react-icons/bs";
import { FaUsersLine } from "react-icons/fa6";
import HandleCurrentPath from "./HandleCurrentPath";
import { TbPackages } from "react-icons/tb";

const Menu = () =>{

  const pathname = window.location.pathname;
 
    return(
        <>
        <ul className="mt-6">
                <li className="relative px-6 py-3">
                 
                <HandleCurrentPath staticPath={'/'} currentPath={pathname} />
                <Link
                    className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    <FcOrgUnit />
                    <span className="ml-4">Dashboard</span>
                </Link>
                </li>
            </ul>

        <ul>

         
        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/client'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/client'} >
                <FaUsersLine/>
                <span className="ml-4">Client </span>
            </Link>
        </li>
        
        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/maTravelPackage'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/maTravelPackage'} >
                <TbPackages/>
                <span className="ml-4">MaTravelPackage </span>
            </Link>
        </li>

        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/mapackageitem'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/mapackageitem'} >
                <FcPackage/>
                <span className="ml-4">Mapackageitem </span>
            </Link>
        </li>

        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/matravelpackageinclusion'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/matravelpackageinclusion'} >
                <FcManager/>
                <span className="ml-4">Matravelpackageinclusion </span>
            </Link>
        </li>

        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/matravelpackageexclusion'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/matravelpackageexclusion'} >
                <FcManager/>
                <span className="ml-4">Matravel Package Exclusions </span>
            </Link>
        </li>

        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/invoices'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/invoices'} >
                <FcManager/>
                <span className="ml-4">Invoices </span>
            </Link>
        </li>

    

    </ul>
        </>
    );
}
export default Menu;